export const dashboardPaths = {
  trafficAnalysis: "/optimization/funnel",
  trafficDetails: "/optimization/traffic-details",
  trafficDetailsCountries: "/traffic-details/countries",
  competitorsMonitoring: "/competitors-monitoring",
  competitorFocus: "/competitor-focus",
  brandWayback: "/brand-wayback",
  competitorDomain: "/competitor/:domain",
  businessOverview: "/optimization/overview",
  brandOverview: "/brand-overview",
  textAds: "/text-ads",
  productListingAds: "/product-listing-ads",
  conversionsAnalysis: "/optimization/conversions-analysis",
  campaignExplorer: "/optimization/campaigns",
  competitiveIntelligence: "/competitive-intelligence/overview",
  competitionEvolution: "/competitive-intelligence/competition-evolution",
  competitiveSearchTermAnalysis: "/competitive-intelligence/st-analysis",
  competitiveAds: "/competitive-intelligence/ads",
  nonBrandedSearchTerms: "/non-branded/search-terms",
  nonBrandedCompetitors: "/non-branded/competitors",
  nonBrandOverview: "/non-branded",
  brandPulse: "/brand-pulse",
  brandPulseCompetitorsSelection: "/brand-pulse/competitors-selection",
  brandPulseCompetitors: "/brand-pulse/competitors",
  clusterManager: "/optimization/cluster-manager",
}; 